import React from "reactn";
import { BoxForm } from "../../../../../components/UI/form";
import { Icon } from "semantic-ui-react";
import EmailTemplateModal from "../../../../../components/modals/EmailTemplateModal";
import TextTemplateModal from "../../../../../components/modals/TextTemplateModal";
import axios from "axios";

class Template extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      openTemplateModal: false,
      openTextTemplateModal: false
    };
  }

  handleChange = (e, v) => {
    this.props.onAutomationChange({ [e]: v });
  };

  handleCreateTemplate = () => {
    const { automation } = this.props;
    if (automation.communicationType === 'email') {
      this.setState({ openTemplateModal: true });
    } else if (automation.communicationType === 'text') {
      this.setState({ openTextTemplateModal: true });
    }
  };

  customForm = () => {
    const { automation, templates } = this.props;
    const inputFieldsStyle = {
      fontSize: window.innerWidth < 768 ? '0.85rem' : '1.1rem',
      whiteSpace: 'normal',
      wordWrap: 'break-word'
    };

    return (
      <div className="formbody" style={{ 
        padding: '0',
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 4px 12px rgba(75, 75, 75, 0.6)',
        border: '1px solid rgb(190, 190, 190)',
        overflow: 'hidden',
        transition: 'all 0.3s ease',
        width: '100%',
        maxWidth: '800px', 
        margin: '0 auto'
      }}>
        {/* card header */}
        <div style={{
          padding: '8px 8px',
          borderBottom: '1px solid #e6f0ff',
          backgroundColor: '#f8fbff', 
          textAlign: 'center'
        }}>
          <h2 style={{
            margin: 0,
            fontSize: window.innerWidth < 768 ? '1.4rem' : '1.75rem',
            color: '#1a56db',
            fontWeight: window.innerWidth < 768 ? '600' : '700',
            letterSpacing: '-0.025em'
          }}>
            Template Selection
          </h2>
        </div>

        {/* body */}
        <div style={{ 
          padding: window.innerWidth < 768 ? '15px' : '20px',
          backgroundColor: 'white'
        }}>
          <form>
            <div style={{ maxWidth: '700px', margin: '0 auto' }}>
              <div style={{ 
                display: 'flex', 
                alignItems: 'center',
                marginBottom: '24px',
                gap: window.innerWidth < 768 ? '8px' : '24px',
                padding: window.innerWidth < 768 ? '12px' : '20px',
                backgroundColor: 'rgb(255, 255, 255)',
                borderRadius: '12px',
                border: '2px solid rgb(230, 230, 230)',
              }}>
                <label style={{ 
                  minWidth: window.innerWidth < 768 ? '100px' : '180px',
                  fontSize: window.innerWidth < 768 ? '0.85rem' : '1.1rem',
                  color: '#1f2937',
                  fontWeight: '600'
                }}>
                  Select Template<span style={{ color: '#ef4444', marginLeft: '4px' }}>*</span>
                </label>
                <Icon 
                  name='info circle' 
                  style={{ 
                    color: 'rgb(0, 0, 0)',
                    marginRight: '-8px',
                    marginBottom: '10px',
                    fontSize: window.innerWidth < 768 ? '0.9rem' : '1.3rem',
                  }}
                  title="Choose an existing template for your automation"
                />
                <select
                  className="input-fields"
                  style={{ 
                    flex: 1,
                    padding: window.innerWidth < 768 ? '6px 8px' : '12px 16px',
                    fontSize: window.innerWidth < 768 ? '0.85rem' : '1.1rem',
                    height: window.innerWidth < 768 ? '35px' : '50px',
                    borderRadius: '8px',
                    border: '1px solid #e6f0ff',
                    backgroundColor: 'rgb(233, 233, 233)',
                    cursor: automation.automationType ? 'pointer' : 'not-allowed', 
                    minWidth: 0,
                    maxWidth: '100%',
                    width: '100%'
                  }}
                  value={automation?.templateId || ""}
                  name="templateId"
                  onChange={e => this.handleChange(e.target.name, e.target.value)}
                  disabled={!automation.automationType}
                >
                  <option value="" style={inputFieldsStyle}>Select Template</option>
                  {templates
                    .filter(t => t.type === automation.communicationType)
                    .map(t => (
                      <option key={t.id} value={t.id} style={inputFieldsStyle}>{t.title}</option>
                    ))}
                </select>
              </div>

              <div style={{ 
                display: 'flex', 
                alignItems: 'center',
                 gap: window.innerWidth < 768 ? '8px' : '24px',
                padding: window.innerWidth < 768 ? '12px' : '20px',
                backgroundColor: 'rgb(255, 255, 255)',
                borderRadius: '12px',
                border: '2px solid rgb(230, 230, 230)',
                cursor: automation.automationType ? 'pointer' : 'not-allowed',
                transition: 'all 0.2s ease',
                opacity: automation.automationType ? 1 : 0.6, 
                minHeight: window.innerWidth < 768 ? '30vh' : '40vh'
              }}
              >
                <label style={{ 
                  minWidth: window.innerWidth < 768 ? '100px' : '180px',
                  fontSize: window.innerWidth < 768 ? '0.85rem' : '1.1rem',
                  color: '#1f2937',
                  fontWeight: '600'
                }}>
                  Create New Template
                </label>
                <Icon 
                  name='info circle' 
                  style={{ 
                    color: 'rgb(0, 0, 0)',
                    marginRight: '-8px',
                    marginBottom: '10px',
                    fontSize: window.innerWidth < 768 ? '0.9rem' : '1.3rem',
                  }}
                  title="Create a new template for your automation"
                />
                <div style={{ 
                  flex: 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: window.innerWidth < 768 ? '25vh' : '35vh',
                  borderRadius: '8px',
                  border: '2px dashed rgb(180, 180, 180)',
                  backgroundColor: 'rgb(248, 248, 248)',
                  transition: 'all 0.2s ease'
                }}
                onClick={automation.automationType ? this.handleCreateTemplate : undefined}
                >
                  <Icon 
                    name='plus circle' 
                    style={{ 
                      fontSize: window.innerWidth < 768 ? '1.5rem' : '2rem',
                      color: 'black',
                      margin: 0,
                      padding: 0
                    }}
                  />
                </div>
              </div>
            </div>
          </form>
        </div>

        <EmailTemplateModal
          onSave={async () => {
            try {
              const ep = `${process.env.REACT_APP_API}/partners/connections`;
              const response = await axios.get(ep);
              if (response.data.success) {
                this.props.onAutomationChange({ 
                  templateId: "",
                  templates: response.data.data.templates 
                });
              }
            } catch (error) {
              console.error("Error refreshing templates:", error);
            }
          }}
          onClose={() => this.setState({ openTemplateModal: false })}
          open={this.state.openTemplateModal}
          allTemplates={templates}
        />
        <TextTemplateModal
          onSave={async () => {
            try {
              const ep = `${process.env.REACT_APP_API}/partners/connections`;
              const response = await axios.get(ep);
              if (response.data.success) {
                this.props.onAutomationChange({ 
                  templateId: "",
                  templates: response.data.data.templates 
                });
              }
            } catch (error) {
              console.error("Error refreshing templates:", error);
            }
          }}
          onClose={() => this.setState({ openTextTemplateModal: false })}
          open={this.state.openTextTemplateModal}
          allTemplates={templates}
        />
      </div>
    );
  };

  render() {
    return (
      <BoxForm
        handleChange={this.handleChange}
        name={""}
        customForm={this.customForm()}
      />
    );
  }
}

export default Template;